export interface ListOfCitiesEntity {
  airportFullName?: string;
  airportCode?: string;
  airportName?: string;
  cityCode?: string;
  cityName?: string;
  countryCode?: string;
  region?: string;
  aliases?: string[] | null;
  locationCode?: string;
  city?: string;
  address?: string;
  description?: string;
  locationTypeCode?: string | null;
}

export interface PredictiveRentalCarsResponse {
  code: string;
  listOfCities?: ListOfCitiesEntity[] | null;
}

export interface PredictiveCitiesResponse {
  code: string;
  listOfCities?: ListOfCitiesEntity[] | null;
  status?: string;
}
